import React, { useContext, useState } from "react";
import "./leadscreate.css";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ProfileContext } from "../../../context/ProfileContext";
import { LeadsCreateAPI } from "../api/LeadsAPI";
import { errorUI, requireUI, successUI } from "../../../styled/Swal";
import { ArrowLeft } from "lucide-react";

const leadObj = {
  firstName: "",
  lastName: "",
  fullName: "",
  mobile: "",
  email: "",
  city: "",
  source: "",
  sourceId: "",
};


function LeadsCreate() {
  const { user } = useContext(ProfileContext);
  const { openSidebar } = useOutletContext();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    fullName: "",
    mobile: "",
    email: "",
    city: "",
    source: user?.fullName || "",
    sourceId: user?._id || "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // Mobile: allow only numbers
    if (name === "mobile") {
      updatedValue = value.replace(/\D/g, ""); // remove non-digits
    }

    let updatedForm = {
      ...form,
      [name]: updatedValue.trimStart(),
    };

    // Auto calculate full name
    if (name === "firstName" || name === "lastName") {
      const first = name === "firstName" ? updatedValue : form.firstName;
      const last = name === "lastName" ? updatedValue : form.lastName;

      updatedForm.fullName = `${first.trim()} ${last.trim()}`.trim();
    }

    setForm(updatedForm);
  };

  const validate = () => {
    let newErrors = {};
    // Mobile validation
    if (!/^\d{10}$/.test(form.mobile)) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
    }
    // Email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = "Enter a valid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Trim first before validation
    const trimmedForm = {
      ...form,
      firstName: form.firstName?.trim(),
      lastName: form.lastName?.trim(),
      email: form.email?.trim(),
      mobile: form.mobile?.trim(),
      fullName: form.fullName?.trim(),
    };

    if (!trimmedForm.firstName || 
        !trimmedForm.lastName || 
        !trimmedForm.email || 
        !trimmedForm.mobile) {
      requireUI("All required fields must be filled!");
      return;
    }

    if (!validate()) return;

    try {
      const res = await LeadsCreateAPI(trimmedForm);

      if (res.success) {
        successUI("Lead created successfully!");

        setForm({
          ...leadObj,
          source: user?.fullName || "",
          sourceId: user?._id || "",
        });
        navigate('/leads')
        setErrors({});
      } else {
        errorUI(res?.message);
      }
    } catch (error) {
      errorUI(error?.message || "Something went wrong");
    }
  };

  return (
    <div className="rp-create-leads-page">
      <ProfileHeader onMenuClick={openSidebar} val="Create Client Leads" />
      
      <form className="rp-create-leads-form" onSubmit={handleSubmit}>
        <div className="rp-create-leads-actions">
          <button onClick={()=>navigate('/dashboard')} type="button" className="rp-create-leads-save-btn">
            <ArrowLeft size={16}/> Back
          </button>
          <button type="submit" className="rp-create-leads-save-btn">
            Save Client
          </button>
        </div>
        <div className="rp-create-leads-grid">

          <div className="rp-create-leads-field">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="rp-create-leads-field">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="rp-create-leads-field">
            <label>Full Name (Auto)</label>
            <input
              type="text"
              value={form.fullName}
              readOnly
            />
          </div>

          <div className="rp-create-leads-field">
            <label>Mobile</label>
            <input
              type="text"
              name="mobile"
              maxLength={10}
              value={form.mobile}
              onChange={handleChange}
              required
              className={errors.mobile ? "error-input" : ""}
            />
            {errors.mobile && <p className="error">{errors.mobile}</p>}
          </div>

          <div className="rp-create-leads-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className={errors.email ? "error-input" : ""}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>

          <div className="rp-create-leads-field">
            <label>City</label>
            <input
              type="text"
              name="city"
              value={form.city}
              onChange={handleChange}
            />
          </div>

          <div className="rp-create-leads-field">
            <label>Source Name</label>
            <input
             className="rp-personalinfo-input"
              type="text"
              value={form.source}
              readOnly
              disabled
            />
          </div>

        </div>
      </form>
    </div>
  );
}

export default LeadsCreate;
